// src/components/Login.js
import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase/firebaseAuth';
import Logo from "../resources/revivalGrey-1-block.png";
import { useNavigate } from 'react-router-dom';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/live-streaming'); 
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div id='login-page'>
        <div className='login-form'>
          <img src={Logo} width="30%"/>
          <h3>RCC Demo</h3>
            <form onSubmit={handleLogin}>
            <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
            />
            <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
            />
            <br/>
            <button type="submit">Login</button>
            </form>
        </div>
    </div>
  );
}

export default Login;
